import {Routes, locOrig} from "../../API";

export default {
    state: {
        allMarketplaces: [],
        lang: null,
        buttons: '',
        isCloseButton: true,
        isVisibilityModal: false
    },
    actions: {
        async fetchMarketplaces(ctx) {
            const response = await fetch(`${locOrig}/${Routes.marketplaces}`)
            const marketplaces = await response.json()
            ctx.commit('updateMarkets', marketplaces)
        },
        async fetchVideo(ctx) {
            const response = await fetch(`${locOrig}/${Routes.video}`)
            const video = await response.json()
            ctx.commit('updateVideo', video)
        },
        async fetchLand(ctx) {
            const response = await  fetch(`${locOrig}/${Routes.testBurger}`)
            const lang = await response.json()
            ctx.commit('updateLang', lang)
        },
        modalAction({commit}, isVisibilityModal) {
            commit('editModal', isVisibilityModal)
        },
        buttonAction({commit}, isCloseButton) {
            commit('buttonMutation', isCloseButton)
        }
    },
    mutations: {
        updateMarkets(state, marketplaces) {
            state.allMarketplaces = marketplaces
            state.buttons = marketplaces
        },
        updateVideo(state, video) {
            state.video = video
        },
        updateLang(state, lang) {
            state.lang = lang.UserLng
        },
        editModal(state, modal) {
            state.isVisibilityModal = modal
        },
        buttonMutation(state, modal) {
            state.isCloseButton = modal
        }
    },
    getters: {
        videoFile(state) {
            return state.video[state.lang].startScreen
        },
        marketplaces(state) {
            return state.allMarketplaces[state.lang]
        },
        lang(state) {
            return state.lang
        },
        MarketItems(state, getters) {

            return getters.marketplaces.list.map((item, index) => {
                return {
                    id: index,
                    name: item.title,
                    image: `${locOrig}` + item.img_desc,
                    url: item.url,
                    urlLow:  item.url.substring(0.8),
                    imageMob: `${locOrig}` + item.img_mob
                }
            })
        },
        videoItems(state, getters) {
            return getters.videoFile.map((item) => {
                return {
                    video: `${locOrig}` + item.starterVideo
                }
            })
        }
    }
}